"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSignature = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M34.3 21.324l6.152-5.982 20.37 20.948-6.15 5.982zM58.7 46.42a10.29 10.29 0 0 0 5.67 3l3.83.58-.54-3.84a10.29 10.29 0 0 0-2.81-5.75l-1.9-2-6.15 6zM36.79 11.59a4.29 4.29 0 1 0-6.15 6l1.53 1.57 6.15-6zM30.37 19.39a1.52 1.52 0 1 0-2.19 2.13l11.26 11.57A1.52 1.52 0 0 0 41.62 31l-8.38-8.61-2.13-2.19zM65.11 58.24H21.27a5.4 5.4 0 0 1-5.4-5.4v-.46a5.4 5.4 0 0 1 5.4-5.4H35.9a2.2 2.2 0 0 0 2.2-2.2v-.15a2.2 2.2 0 0 0-2.2-2.2H12.76a5.4 5.4 0 0 1 0-10.79h3.95a2.2 2.2 0 0 0 2.2-2.2V29a2.2 2.2 0 0 0-2.2-2.2H2.44a1.6 1.6 0 0 1 0-3.2h14.27a5.4 5.4 0 0 1 5.4 5.4v.51a5.4 5.4 0 0 1-5.4 5.4h-3.95a2.2 2.2 0 0 0 0 4.39H35.9a5.4 5.4 0 0 1 5.4 5.4v.15a5.4 5.4 0 0 1-5.4 5.4H21.27a2.2 2.2 0 0 0-2.2 2.2v.46a2.2 2.2 0 0 0 2.2 2.2h43.84a1.6 1.6 0 0 1 0 3.2z"
  })),
  height: undefined,
  width: undefined
});
IconSignature.displayName = 'IconSignature';
var _default = IconSignature;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/signature.js
// module id = 336
// module chunks = 0